Vue.component('commodity-info', {
    props: ['commodity'],
    data() {
        return {
            open : false,
        }
    },
    computed: {
        //
    },
    methods: {
        toggle() {
            this.open = !this.open;
        },
    },
    mounted() {
        //
    }
});